import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  ...enLocale,
  header: {
    currentLang: 'languages',
    title: 'Self-Service Platform  ',
    ai_title: 'AI Music Publishing Platform',
    home: 'Home',
    profile: 'Profile',
    help: 'Help',
    about: 'About',
    login: 'Login',
    logout: 'Logout',
    language: 'Language',
  },
  account: {
    passwordLogin: 'Log In with email',
    phoneNumLogin: 'Log In with phone number',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    phoneNumPlaceholder: 'Phone Number',
    codePlaceholder: 'Verification Code',
    sendCode: 'Send Code',
    reSend: 'Resend',
    nicknamePlaceholder: 'Username',
    forgetPassword: 'Forgot Password',
    registerAccount: 'Create New Account',
    passwordAgainPlaceholder: 'Password',
    login: 'Log In',

    phoneNumError: 'Invalid phone number',
    codeError: 'Invalid verification code',

    register: 'Sign Up',
    registerCallback: 'Success',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',

    forgotPassword: 'Forgot Password',
    forgotPasswordDesc: 'Please enter your email to search for your account.',
    submit: 'Submit',
    forgetSuccessMessage: 'Success. Please check the the verification email and reset your password.',
    resetSuccessMessage: 'Success. Please log in.',

    resetPassword: 'Reset Password',
    emailValidPlaceholder: 'Please confirm your email',
    passwordValidPlaceholder: 'Please choose a password that is 6 to 12 characters long and contains at least 1 letter, 1 number, and 1 of the special characters.',
    passwordAgainValidPlaceholder: 'Please confirm your password',
    nicknameValidPlaceholder: 'Please choose a username within 10 characters',

    registerSuccess: 'Success.',
    toLogin: 'Please log in.',

    registerSuccessMessage: 'Success. Please check the the verification email and activate your account.',
    registerEmailUsed: 'This email address has already been registered. Please log in.',

    sendEmailError: 'Verification Email Failed.',
    emailNotRegistered: 'This email address cannot be found.',
    overclock: 'Please try it 30 mins later.',
    emailError: 'Please confirm your email.',
    wrongPassword: 'Wrong Password.',
    inactive: 'Please check your account verification email.',
    pastDue: 'The verification email is no longer valid. Please register it again.',
    invalidEmail: 'Invalid email.',

    doneError: 'operation failure',

    verifyCodeError: 'Verification code error',
    sendCodeFailed: 'Send verification code failed',
    phoneNumRegisterFailed: 'Phone number registration failed',
    shotPicVerifyCode: 'shot picture verify code',
    phoneBound: 'Phone number has been bound',

    confirm: 'OK'

  },
  home: {
    contentManage: 'Content Management',
    contentManageDesc: 'Convenient information management One-click release of works',
    selfPublish: 'Self Publishing',
    selfPublishDesc: 'One-stop publishing platform Easily reach global platforms',
    dataService: 'Data Service',
    dataServiceDesc: 'Visualized data report Real-time grasp of works dynamics',
    cpProtect: 'Rights Protection',
    cpProtectDesc: 'Online rights appeal Timely insight into risks',
    fastSign: 'Fast Sign',
    fastSignDesc: 'Professional cooperation to promote content development',
    fastSettlement: 'Fast Settlement',
    fastSettlementDesc: 'Transparent and visible settlement data for all-round works',
  },
  nav: {
    profile: '@:header.profile',
    basic: 'Basic Profile',
    message: 'Notice',
    registry: 'Registry',

    contentManagement: 'Discography',
    trackManagement: 'Track',
    albumManagement: 'Album',
    mvManagement: 'Video',
    singerManagement: 'Artist',
    contractManagement: 'Contract',

    modifyRecord: 'Editing Records',
    modifyTrack: 'Audio',
    modifyAlbum: 'Album',
    modifyMv: 'Video',

    data: 'Data Management',
    product: 'Products Data',
    user: 'Customer data',
    songlist: 'Songlist Data',

    income: 'Revenue',
    settle: 'Settlement',

    appeal: 'Rights Appeal',
    history: 'Appeal History',
    toAppeal: 'Rights Appeal',
    appealEdit: 'Appeal Edit',
  },

  common: {
    search: 'Search',
    export: 'Export All',
    modify: 'Modify',
    cancel: 'Cancel',
    noResult: 'there is no match result',
    empty: 'empty',

    singerName: 'Artist',
    singerNamePlaceholder: 'Please input the artist name',
    status: 'Status',
    statusPlaceholder: 'please select status',
    contract: 'Contract',
    contractPlaceholder: 'please input contract',
    statusMap: {
      0: 'All',
      1: 'Pending',
      2: 'Taken down',
      3: 'Verifing',
      4: 'Rejected',
      5: 'Alive'
    },
    hiddenReasonMap: {
      0: 'Taken Down by TME',
      1: 'No Audio File',
      2: 'Duplicate File',
      3: 'Bad Audio Quality',
      4: 'Taken Down by TME',
      5: 'Taken Down by TME',
      6: 'Taken Down by TME',
      7: 'Taken Down by TME',
      8: 'Taken Down by TME',
      10: 'Taken Down by TME',
      11: 'Taken Down by TME',
      12: 'Will Live Soon',
      13: 'Taken Down by TME',
      15: 'Taken Down by TME',
      16: 'Taken Down by TME',
      17: 'Taken Down by TME',
      18: 'Copyright Dispute'
    },
    hiddenTrack: 'Hidden Track',
    hiddenTrackPlaceholder: 'Hidden Reason',
    upcPlaceholder: 'please input the UPC',
    relateCompany: 'Related Label',
    publicTime: 'Release Date',
    publicTimePlaceholder: 'please select release date',
    uploadTime: 'Upload Time',
    uploadTimePlaceholder: 'please select upload time',

    flowStatus: {
      uploading: 'Uploading Files',
      processing: 'Processing',
      manualChecking: 'Manual Checking',
      approved: 'Approved',
      rejected: 'Rejected',
      warehousing: 'Warehousing',
      pending: 'Pending',
      online: 'online',
      takeDown: 'Taken Down',
      platform: 'App Status'
    }
  },

  const: {
    isOnlyMap: {
      0: 'non exclusive',
      1: 'exclusive',
    },
    isAgentMap: {
      0: 'Label',
      1: 'distributor'
    },
    canLegalRightsMap: {
      0: 'non exclusive',
      1: 'exclusive',
    },
    paymentMap: {
      1: '免费',
      3: '1.0模式',
      5: '2.0模式',
      10: '3.0模式',
    }
  },

  person: {
    edit: 'Edit Profile',
    basic: 'Basic Profile',
    registryInfo: 'This platform is only for TME partner labels, other labels please go to https://y.tencentmusic.com/',
    partner: 'Partner Labels',
    notPartner: 'Non Partner Labels',
    role: 'Role',
    isSign: 'isSign',
    production: 'production',
    companyName: 'Company Name',
    namePlaceholder: 'Full name of your company',
    legalPerson: 'Legal Person',
    legalPersonPlaceholder: 'Should be the same with the one on the Business License of Legal Entity',
    email: 'Email',
    emailPlaceholder: 'Email',
    address: 'Address',
    addressPlaceholder: 'Address',
    phone: 'Phone',
    phonePlaceholder: 'Phone',
    qq: 'QQ Account',
    qqPlaceholder: 'QQ Account',
    license: 'Business Certificate',
    desc: 'Introduction',
    logo: 'icon & logos',
    cpCompany: '版权所属厂牌',
    cpCompanyPlaceholder: 'Please input the copyright company name',
    agentCompany: '代理厂牌',
    agentCompanyTooltip: '用于母公司查看旗下代理的相关子厂牌上传内容情况（旗下无代理厂牌请勿填写，以免影资质审核）',

    nameRule: '请填写公司名',
    photoRule: '只能上传jpg/png文件',
    phtotRule2: '需加盖公章',
    logoRule: '@:person.photoRule',
    corporationRule: 'Please input the legal person',

    profileAuditing: 'profile auditing',
    profileReject: 'reject',
    checked: 'checked',

    roleMap: {
      1: 'Label',
      2: 'Marketing',
      3: 'Licensing',
      4: 'Operations',
      5: 'Others',
      6: 'Finance',
      7: 'Private',
      8: 'Corportion',
      9: 'AI Publishing'
    },

    personHome: 'Person Home',
  },

  track: {
    trackName: 'Track',
    trackNamePlaceholder: 'Please input the track name',
    precise: 'Precise',
    fuzzy: 'Fuzzy',
    isrcPlaceholder: 'please input ISRC',
    exclusivity: 'Exclusivity',
    exclusivityPlaceholder: 'please select exclusivity',
    licensorRole: 'Licensor\'s role',
    licensorRolePlaceholder: 'please select licensor\'s role',
    wmExclusivity: 'Publishing Exclusivity',
    wmExclusivityPlaceholder: 'please select publishing Exclusivity',
    paymentMode: 'Payment mode',
    paymentModePlaceholder: 'please select payment mode',
    version: 'Version',
    trackId: 'Track ID',
    trackIdPlaceholder: 'support input multiple IDs divide by comma',

    showFlow: 'Delivering'
  },

  album: {
    create: 'New Album',
    searchError: 'search error.',
    albumName: 'Album',
    albumNamePlaceholder: 'please input the album name',
    albumId: 'Album ID',
    albumIdPlaceholder: 'support input multiple IDs divide by comma',
    sendMail: 'Email all platforms',
    sendMailSuccess: 'Mail Delivered Successfully',
    showFlow: 'Delivering'
  },

  mv: {
    mvName: 'MV Name',
    mvNamePlaceholder: 'please input the mv name',
    create: 'New MV',
    preview: 'preview',
  },

  singer: {
    type: 'type',
    typePlaceholder: 'all',
    create: 'New Singer',
    twoNewestAlbum: 'two newest album info',
    singerTypeMap: {
      0: 'Male',
      1: 'Female',
      2: 'Group',
      3: 'Other',
      5: 'Virtual'
    }
  },

  modify: {
    applyUser: 'Apply User',
    applyUserPlaceholder: 'use apply user(company name) search',
    auditTime: 'Pass Time',
    auditTimePlaceholder: 'select pass time search',
    insertTime: 'Submit Time',
    insertTimePlaceholder: 'select submit time search',
    status: 'Status',
    statusMap: {
      0: 'unaudited',
      1: 'canceled',
      2: 'pass',
      3: 'reject',
      4: 'auditing'
    },
    auditor: 'Auditor',
    before: 'Before',
    after: 'After',
  },

  data: {
    descTME: 'Only the products you have uploaded through this platform will be displayed here.',
    descAppend: 'Traffic data is the operation caliber real-time data, all settlement of effective broadcast to the financial settlement prevail.',
    descAll: 'Only the products you have rights for will be displayed here.',
    tabs: {
      perform: 'Products Performance',
      apply: 'Popularity Index'
    },
    perform: {
      track: 'Tracks',
      album: 'Albums',
      mv: 'videos',
      singer: 'Artists',

      uploadingOverview: 'Ingestion Overview',
      productOverview: 'Products Data Overview',
      cycleMap: {
        '-9999': 'latest two years',
        '-7': 'latest week',
        '-30': 'latest month'
      },
      streams: 'Streams',
      downloads: 'Downloads',

      paymentOverview: 'Payment Overview',
      paymentDesc: 'Click the Sector Graph to see more deaitals about streams',

      isAgentN: 'Licensor as label',
      isAgentY: 'Licensor as distributor',
      isOnlyN: 'exclusive publishing license',
      isOnlyY: 'non-exclusive publishing license',
      canLegalRightsY: 'Exclusive',
      canLegalRightsN: 'Non Exclusive',
      free: 'freemium',
      payment: 'premium'
    },

    apply: {
      platform: 'Stores',
      platformMap: {
        tme: 'All',
        qq: 'QQ',
        kg: 'KUGOU',
        kw: 'KUWO'
      },
      hottest: 'Hottest',
      newest: 'Newest',
      increase: 'Increase',
      decrease: 'Decrease',

      no: 'No.',
      trackInfo: 'Track info',
      version: 'Version',
      language: 'Language',
      streamsAndIndex: 'Streams(Index)',
      downloadsAndIndex: 'Downloads(Index)',
      favoritesAndIndex: 'Favorites(Index)',
      streamsIndex: 'Streams Index',
      downloadsIndex: 'Downloads Index',
      favoritesIndex: 'Favorites Index',
      streams: 'Streams',
      downloads: 'Downloads',
      favorites: 'Favorites',
      remarks: 'Comments',
      remarksIncrease: 'Comments Increase',
      trend: 'Trend',
      qqRank: 'Highest Rank on QQ Music Hot Song Chart',
      kugouRank: 'Highest Rank on Kuwo Hot 500 Chart',

      interval: 'Period',
      to: 'To'
    },

    fans: {
      total: 'Total Number of Listeners',
      yesterday: 'Total Number of Yesterday\'s Listeners',
      terminal: 'Terminals',
      gender: 'Gender',
      area: 'Territory',
      top: 'TOP 10 Cities',
      移动端: 'mobile',
      PC端: 'PC',
      男生: 'male',
      女生: 'female'
    }
  },

  appeal: {
    cpTitle: 'Licensed Track',
    appealTitle: 'Disputed Track',
    downloadTemplate: 'Batch Query Model',
    batchSearch: 'Batch Query',
    batchLink: 'Batch Link'
  },

  cpTask: {
    cpTaskTitle: 'copyright task',
    cpTaskListTitle: 'copyright task list',
    cpTaskDetailTitle: 'copyright task detail',
    taskId: 'task ID',
    taskIdPlaceholder: 'support input multiple IDs divide by comma',
    taskName: 'task name',
    taskNamePlaceholder: 'please input the task name, support fuzzy search',
    buyId: 'purchase ID',
    buyIdPlaceholder: 'support input multiple IDs divide by comma',
    contentType: 'content type',
    contentTypePlaceholder: 'please select content type',
    buyType: 'purchase type',
    buyTypePlaceholder: 'please select purchase type',
    reviewStatus: 'review status',
    reviewStatusPlaceholder: 'please select review status',
    status: 'status',
    statusPlaceholder: 'please select status',
    businessBroker: 'business broker',
    businessBrokerPlaceholder: 'please select business broker',

    createTask: 'create copyright task',
    editTask: 'edit',
    detailTask: 'detail',
    findTracks: 'tracks',
    exportTracks: 'export',
    stopTask: 'stop',
    runTasl: 'run',
  },

  message: 'hello i18n !!'
}
